/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useDatatables } from "App/hooks";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { TableCell, TableRow, makeStyles, CircularProgress } from "@material-ui/core";
import {
  getListKetersediaanSirsOL,
  headCellsKetersediaanRsOl,
  updateKetersediaanSirsOnline
} from "./helpers";

import {
  defaultToastError,
  defaultToastSuccess,
} from "App/utils/helpers";

import {
  InputTextMaster,
  MasterButton,
  Modal,
  TableWrapper,
} from "App/Component/ui";

const useStyles = makeStyles(() => ({
  modalContainer: {
    position: 'relative',
    minHeight: '200px',
  },
  loadingOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  spinner: {
    width: '40px !important',
    height: '40px !important',
    borderRadius: '50% !important',
  }
}));

function ModalKetersediaanRsOL({ setShowModal, id }) {
  const classes = useStyles();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);

  const setNewData = async () => {
    try {
      setLoading(true);
      const response = await getListKetersediaanSirsOL(id);

      if (response.state) {
        setRows(response.data);
      } else {
        defaultToastError(response.message);
        // setRows([]);
      }
    } catch (error) {
      console.error("Gagal memuat data ketersediaan:", error);
      defaultToastError("Terjadi kesalahan saat memuat data");
      // setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setNewData();
  }, []);

  return (
    <>
      <Modal title='Ketersediaan KLS RS OL' width={"70%"} show={setShowModal}>
        <div className={classes.modalContainer}>
          {(loading || updateLoading) && (
            <div className={classes.loadingOverlay}>
              <CircularProgress className={classes.spinner} />
            </div>
          )}
          <TableListKetersediaanRsOL
            rows={rows}
            refreshData={setNewData}
            setUpdateLoading={setUpdateLoading}
          />
        </div>
      </Modal>
    </>
  );
}

const TableListKetersediaanRsOL = ({ rows, refreshData, setUpdateLoading }) => {
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  const [loadingStates, setLoadingStates] = useState({});

  return (
    <TableWrapper
      title='Daftar Ketersediaan'
      setQ={setQ}
      withAddButton={false}
      withExportButton={false}
      order={order}
      orderBy={orderBy}
      handleRequestSort={handleRequestSort}
      length={length}
      rows={rows}
      headCells={headCellsKetersediaanRsOl}
      page={page}
      setPage={setPage}
      rowsPerPage={rowsPerPage}
      setRowsPerPage={setRowsPerPage}>
      {stableSort(data, getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((row, index) => {
          return <TableRowKetersediaanRsOL
            index={index}
            key={row.kode}
            row={row}
            isLoading={loadingStates[row.kode] || false}
            setLoadingStates={setLoadingStates}
            refreshData={refreshData}
            setUpdateLoading={setUpdateLoading}
          />;
        })}
    </TableWrapper>
  );
};

const btnStyles = {
  default: {
    name: 'UPDATE',
    color: 'green',
  },
  loading: {
    name: 'UPDATING...',
    color: 'gray',
  }
};

const TableRowKetersediaanRsOL = ({
  index,
  row,
  isLoading,
  setLoadingStates,
  refreshData,
  setUpdateLoading
}) => {
  const [formData, setFormData] = useState({
    // jumlah_ruang: row.jumlah_ruang || row.bed_tersedia || 0,
    jumlah_bed: row.jumlah_bed || 0,
    antrian: row.antrian || 0,
    terpakai: row.terpakai || 0,
    terpakai_dbd: row.terpakai_dbd || 0,
    terpakai_dbd_anak: row.terpakai_dbd_anak || 0
  });

  const handleChange = (text) => (e) => {
    const value = e.target.value;
    setFormData(prev => ({
      ...prev,
      [text]: value
    }));
  };

  const handleClickUpdate = async (row) => {
    try {
      setUpdateLoading(true);
      setLoadingStates(prev => ({
        ...prev,
        [row.kode]: true
      }));

      const payload = {
        kode_kelas: row.kode_kelas ?? null,
        nama_ruang: row.name ?? null,
        prepare: 0,
        prepare_plan: 0,
        jumlah: parseInt(formData.jumlah_bed ?? row.jumlah_bed ?? 0),
        terpakai: parseInt(formData.terpakai ?? row.terpakai ?? 0),
        terpakai_dbd: parseInt(formData.terpakai_dbd ?? 0),
        terpakai_dbd_anak: parseInt(formData.terpakai_dbd_anak ?? 0),
        antrian: parseInt(formData.antrian ?? 0),
      };

      const response = await updateKetersediaanSirsOnline(payload);

      if (response.state) {
        setUpdateLoading(false);
        setLoadingStates(prev => ({
          ...prev,
          [row.kode]: false
        }));
        defaultToastSuccess(response?.message);
        await refreshData();
      } else {
        defaultToastError(response?.message);
        setUpdateLoading(false);
        setLoadingStates(prev => ({
          ...prev,
          [row.kode]: false
        }));
      }
    } catch (error) {
      defaultToastError(error?.message);
      setUpdateLoading(false);
      setLoadingStates(prev => ({
        ...prev,
        [row.kode]: false
      }));
    }
  };

  return (
    <>
      <TableRow
        hover
        tabIndex={-1}
        key={index}
        style={{
          backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
        }}>
        <TableCell component='th' scope='row' padding='none' align='center'>
          {index + 1}
        </TableCell>
        <TableCell align='left' width={"10%"}>{row?.kode}</TableCell>
        <TableCell align='left'>{row?.name}</TableCell>
        {/* <TableCell align='left'>
          <InputTextMaster
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) e.preventDefault();
            }}
            name={`jumlah-ruang-${index}`}
            label=''
            id={`jumlah-ruang-${index}`}
            value={formData.jumlah_ruang}
            onChange={handleChange("jumlah_ruang")}
            placeholder='Jumlah Ruang'
          />
        </TableCell> */}
        {/* <TableCell align='left'>
          <InputTextMaster
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) e.preventDefault();
            }}
            name={`antrian-${index}`}
            label=''
            value={formData.antrian}
            id={`antrian-${index}`}
            onChange={handleChange("antrian")}
            placeholder='Antrian'
          />
        </TableCell> */}
        <TableCell align='left'>
          <InputTextMaster
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) e.preventDefault();
            }}
            name={`jumlah-bed-${index}`}
            label=''
            value={formData.jumlah_bed}
            id={`jumlah-bed-${index}`}
            onChange={handleChange("jumlah_bed")}
            placeholder='Jumlah TT Tersedia'
          />
        </TableCell>
        <TableCell align='left'>
          <InputTextMaster
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) e.preventDefault();
            }}
            name={`terpakai-${index}`}
            label=''
            id={`terpakai-${index}`}
            value={formData.terpakai}
            onChange={handleChange("terpakai")}
            placeholder='Jumlah TT Terpakai'
          />
        </TableCell>
        <TableCell align='left'>
          <InputTextMaster
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) e.preventDefault();
            }}
            name={`terpakai-dbd-${index}`}
            label=''
            id={`terpakai-dbd-${index}`}
            value={formData.terpakai_dbd}
            onChange={handleChange("terpakai_dbd")}
            placeholder='Terpakai DBD'
          />
        </TableCell>
        <TableCell align='left'>
          <InputTextMaster
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) e.preventDefault();
            }}
            name={`terpakai-dbd-anak-${index}`}
            label=''
            id={`terpakai-dbd-anak-${index}`}
            value={formData.terpakai_dbd_anak}
            onChange={handleChange("terpakai_dbd_anak")}
            placeholder='Terpakai DBD Anak'
          />
        </TableCell>
        <TableCell align='center'>
          <MasterButton
            {...(isLoading ? btnStyles.loading : btnStyles.default)}
            type='button'
            disabled={isLoading}
            onClick={() => handleClickUpdate(row)}
          />
        </TableCell>
      </TableRow>
    </>
  );
};

export default ModalKetersediaanRsOL;
